import React from 'react';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import { AlertIcon } from './../commons/Icons';

import Box from '@mui/material/Box';

class WarningText extends React.Component {

  render() {
    const { classes, children } = this.props;
    return (
      <Box className={clsx(classes.content, this.props.classContent)}>
        <AlertIcon className={clsx(classes.icon, this.props.classIcon)} fontSize="small" />
        {children}
      </Box>
    )
  }
}

const styles = theme => ({
  content: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  icon: {
    marginRight: theme.spacing(1),
  }
});

export default withStyles(styles, { withTheme: true })(WarningText);
